const TOPICS = [
  { id: "housing", label: "Housing" },
  { id: "education", label: "Education" },
  { id: "voting", label: "Voting" },
  { id: "healthcare", label: "Healthcare" },
  { id: "climate", label: "Environment" },
  { id: "criminal_justice", label: "Criminal Justice" },
  { id: "economy", label: "Economy" },
  { id: "immigration", label: "Immigration" },
  { id: "transportation", label: "Transportation" },
  { id: "mental_health", label: "Mental Health" },
  { id: "student_loans", label: "Student Loans" },
  { id: "jobs", label: "Employment" },
  { id: "parental_leave", label: "Parental Leave" },
  { id: "technology", label: "Technology" },
  { id: "other", label: "Other" },
];

export function getTopicDisplayLabel(id) {
  const t = TOPICS.find((x) => x.id === id);
  if (t) return t.label;
  if (!id || typeof id !== "string") return String(id ?? "");
  return id.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default TOPICS;
